import { render, staticRenderFns } from "./UserSetupWelcome.vue?vue&type=template&id=603d5fa8&scoped=true&"
import script from "./UserSetupWelcome.vue?vue&type=script&lang=js&"
export * from "./UserSetupWelcome.vue?vue&type=script&lang=js&"
import style0 from "./UserSetupWelcome.vue?vue&type=style&index=0&id=603d5fa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603d5fa8",
  null
  
)

export default component.exports